import { useEffect } from "react";

const DetectTouch = () => {
    useEffect(() => {
        // Detect if device supports touch
        const isTouchDevice = 
            ('ontouchstart' in window) || 
            (navigator.maxTouchPoints > 0) || 
            (navigator.msMaxTouchPoints > 0);

        // Add appropriate class to html element
        const htmlElement = document.documentElement;
        
        if (isTouchDevice) {
            htmlElement.classList.add('state-touch');
        } else {
            htmlElement.classList.add('state-no-touch');
        }

        // Cleanup function to remove classes if component unmounts
        return () => {
            htmlElement.classList.remove('state-touch', 'state-no-touch');
        };
    }, []); // Empty dependency array - runs only once on mount

    // No visual component needed - this is a utility component
    return null;
};

export default DetectTouch;